// extracted by mini-css-extract-plugin
export var orderDetails = "_td-2";
export var orderImage = "_td-1";
export var orderMeta = "_td-3";
export var orderSummary = "_td-0";
export var rightArrow = "_td-4";